import Layout from "@/layout/Layout.vue";
import { TICKETS_BROWSE_ANY } from "@/config/permissions";

/**
 * Support — tickets et guichets.
 *
 * `noCache` partout : un ticket avance à plusieurs mains, une vue gardée en
 * cache montrerait un état périmé.
 */
const supportRoutes = {
    path: "/support",
    name: "support-root",
    component: Layout,
    redirect: "/support/tickets",
    alwaysShow: true,
    meta: {
        title: "Support",
        icon: "mdi:lifebuoy",
        permissions: TICKETS_BROWSE_ANY
    },
    children: [
        {
            path: "tickets",
            name: "support-tickets",
            meta: {
                title: "Tickets",
                icon: "mdi:ticket-outline",
                permissions: TICKETS_BROWSE_ANY,
                noCache: true,
                // Pastille : tickets à traiter sur mes guichets, collective — elle
                // s'éteint pour tous dès qu'un agent prend le ticket. Déclarée sur
                // CE seul niveau, le SidebarItem la fait remonter sur « Support ».
                badgeKey: "tickets"
            },
            component: () => import("@/views/support/Tickets.vue")
        },
        {
            path: "statistiques",
            name: "support-statistiques",
            meta: {
                title: "Statistiques",
                icon: "mdi:chart-line",
                permissions: TICKETS_BROWSE_ANY,
                noCache: true
            },
            component: () => import("@/views/support/Statistiques.vue")
        },
        {
            // Ouvert depuis la liste : pas d'entrée de menu propre.
            path: "tickets/:id",
            name: "support-ticket",
            hidden: true,
            meta: {
                title: "Ticket",
                permissions: TICKETS_BROWSE_ANY,
                noCache: true,
                activeMenu: "/support/tickets"
            },
            component: () => import("@/views/support/TicketFiche.vue")
        }
    ]
};

export default supportRoutes;
